import { ApiUtility, HttpMethods } from "../Utilities/ApiUtility.axios";
import { IExtractionProgressInfo, IIdNameOption } from "./XcelifyExtractionService"; 
export interface IInvoiceAdminListItem {
  id: string;
  sno?: number;
  practiceId: number;
  number: string;
  autoNumber: number;
  date: string;
  dueDate?: string;
  company?: { id: string; name: string };
  gross: number;
  netAmount: number;
  paid: number;
  due: number;
  status: string;
  reference?: string;
  createdBy?: {
    userId: string;
    userName: string;
    date: string;
  };
}
export interface IInvoiceAdminItemKey {
  id: string;
  practiceId: number;
}
class InvoiceExtractionService {
  route = "/api/Admin/InvoiceExtraction";
  getList = (
    start: number,
    length: number,
    search?: string,
    practiceId: number = 0,
    fromDate?: string,
    toDate?: string,
    companyId?: string,
    status?: string
  ) =>
    ApiUtility.getResult(`${this.route}/List`, {
      start,
      length,
      search,
      practiceId,
      fromDate,
      toDate,
      companyId,
      status,
    });
  getCompaniesByPractice = (practiceId: number) =>
    ApiUtility.getResult<IIdNameOption[]>(`${this.route}/Companies`, {
      practiceId,
    });
  getProgress = (jobId: string) =>
    ApiUtility.getResult<IExtractionProgressInfo>(`${this.route}/Progress/${jobId}`);
  cancelProgress = (jobId: string) =>
    ApiUtility.post(`${this.route}/CancelProgress/${jobId}`, {});
  downloadSingle = (id: string, practiceId: number = 0) =>
    ApiUtility.downloadFile(`${this.route}/DownloadSingle/${id}`, { practiceId }, HttpMethods.get);
  extractBulk = (
    items: IInvoiceAdminItemKey[],
    extractAll: boolean = false,
    practiceId: number = 0,
    fromDate?: string,
    toDate?: string,
    companyId?: string,
    status?: string,
    search?: string,
    jobId?: string,
    signal?: AbortSignal
  ) =>
    ApiUtility.downloadFile(
      `${this.route}/ExtractBulk`,
      { items, extractAll, practiceId, fromDate, toDate, companyId, status, search, jobId },
      HttpMethods.post,
      signal ? { signal } : undefined
    );
}
export default new InvoiceExtractionService();
